const middleware = {}

middleware['auth'] = require('../middleware/auth.js')
middleware['auth'] = middleware['auth'].default || middleware['auth']

middleware['groups'] = require('../middleware/groups.js')
middleware['groups'] = middleware['groups'].default || middleware['groups']

export default middleware
